import React, { useState } from "react";
import { Col, Row, Button, Form } from "react-bootstrap";
import { FaPlusCircle, FaSync } from "react-icons/fa";
import TagForm from "./TagForm";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { notify } from "./notify";
import { logout } from "../actions/userActions";
import Skeleton from "react-loading-skeleton";
import Message from "./Message";
import { CLINIC_DETAILS_RESET } from "../constants/clinicConstants";
import ClinicServiceForm from "./ClinicServiceForm";

const ClinicServices = ({ clinicServices, setClinicServices, clinicId }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const addService = () => {
    setClinicServices([
      ...clinicServices,
      { idx: Math.random(), label: "", price: "" },
    ]);
  };
  const dispatch = useDispatch();
  const updateServices = async () => {
    // update Scans
    try {
      setLoading(true);

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
      const { data } = await axios.put(
        `/api/clinics/${clinicId}/updateClinicServices`,
        {
          clinicServices,
        },
        config,
      );
      setClinicServices(data.updatedClinicServices);
      setLoading(false);
      dispatch({ type: CLINIC_DETAILS_RESET });

      notify({
        title: "Services Update Status",
        message: <p className="lead">Data updated successfully.</p>,
        type: "success",
        duration: 4000,
      });
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      if (message === "Not authorized, token failed") {
        dispatch(logout());
      }
      setError(message);
    }
  };
  return (
    <div>
      {loading ? (
        <Skeleton height="50px" count={3} />
      ) : error ? (
        <Message children={error} variant={`danger`} />
      ) : (
        <>
          {/* <pre>{JSON.stringify(clinicServices, null, 2)}</pre> */}
          <Row>
            <Col className="col-6">
              <Form.Label>Service Name</Form.Label>
            </Col>
            <Col className="col-4">
              <Form.Label>Service Price</Form.Label>{" "}
            </Col>
            <Col className="col-2"> </Col>
          </Row>
          {clinicServices?.map((s) => (
            <div key={s._id || s.idx}>
              <ClinicServiceForm service={s} clinicId={clinicId} />
            </div>
          ))}
          <Button
            className="btn-secondary w-100 my-3"
            onClick={() => addService()}
          >
            <FaPlusCircle className="ms-2" /> Add New Service
          </Button>
          {!loading && (
            <div className="d-flex justify-content-end mt-3 width-100">
              <div>
                <Button variant="outline-info" onClick={() => updateServices()}>
                  <FaSync /> Update
                </Button>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ClinicServices;
